import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-project-management-tracker.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Project Management";

const ProjectManagement = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <TimelineContent
          title={title}
          description="Homegrown and purpose-built for solar, Enerflo Project Management enables smooth progression with important milestone updates, notifications, tasks and more. Customize reports on the data that’s important to you and discover where you may need to step in to help your customers along the way. Get all of the information you need in one place, without having to login to multiple installer CRMs or backend systems."
          link="/features/project-management"
          icon={
            <Image
              src="/images/icons/project-management.svg"
              alt="Icon - Enerflo Project Management"
              layout="responsive"
              height={70}
              width={66}
              quality={100}
              className="crispImage"
            />
          }
        />
        <figure className={clsx(styles.timelineFigure, styles.offsetContent)}>
          <div className="mx-auto w-2/3 md:w-[150%] md:ml-[-25%]">
            <Image
              src={FigureImage}
              alt="Enerflo’s Solar Project Management software keeps everyone involved informed with important milestone updates, notifications, tasks and more."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
      </div>
    </HeroSection>
  </div>
);
export default ProjectManagement;
